import React from 'react';
import { withRouter } from 'react-router-dom';
import Constants, { meetURL } from '../utils/Constants';
import NoDataFound from './NoDataFound';
class VendorRoomViewScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }
    toggleQR = () => {
        this.setState({ showQR: !this.state.showQR });
    };
    handleCopyClick2 = async (copyText) => {
        navigator.clipboard.writeText(copyText);
        this.setState({ isCopied2: true, isCopied1: false })
    }
    handleDownloadQR = async (url, downloadName) => {
        try {
            // Add white margin (padding) around the QR code
            const qrURL = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                url
            )}&size=200x200&margin=20`; // margin=20 adds whitespace around all sides

            const response = await fetch(qrURL);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `${downloadName}_QRCode.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error downloading QR code:', error);
        }
    };
    handleCopyQR = async (inPatientURL) => {
        try {
            const qrURL = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                inPatientURL
            )}&size=200x200&margin=20`;

            // Fetch the image as a blob
            const response = await fetch(qrURL);
            const blob = await response.blob();

            // Convert to ClipboardItem and write to clipboard
            const clipboardItem = new ClipboardItem({ [blob.type]: blob });
            await navigator.clipboard.write([clipboardItem]);
            this.setState({ isCopied2: false, isCopied1: true })

        } catch (err) {
            console.error('Failed to copy QR image:', err);
            alert('Copy failed. Your browser may not support image copy.');
        }
    };


    render() {
        const { data } = this.props;
        // Get vendor_id from room data (should match the vendor who owns the room)
        const vendorId = data?.vendorId || data?.vendor_id;
        // Generate URL: if vendor_id exists, use new flow, otherwise use old flow
        const inPatientURL = vendorId 
            ? `${meetURL.replace("custom/", "")}SRM_IP/patient/${vendorId}`
            : `${meetURL.replace("custom/", "")}SRM_IP/custom/${data?.encryptRoomId || ''}`
        return (
            <div className="content-part px-5 py-4 list">
                <div className="agent-details">
                    <div className='row'>
                        <div className="col-md-6">
                            <div className='row'>
                                <div className='col-6 text-bold'>
                                    Room Number :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomId}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room Name :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.patientRoomName}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    Room code :
                                </div>
                                <div className='col-6'>
                                    <p>{data && data.encryptRoomId}</p>
                                </div>
                                <div className='col-6 text-bold'>
                                    URL :
                                </div>
                                <div className='col-6'>
                                    <div className="d-flex">
                                        <p className="m-0" id="myInput">{inPatientURL}</p>
                                    </div>
                                    <div className='d-flex flex-wrap gap-2'>
                                        <button className="script_code_btn mt-2" onClick={() => this.handleCopyClick2(inPatientURL)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-files" viewBox="0 0 16 16">
                                                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
                                            </svg>
                                            {this.state.isCopied2 ? <p className="m-0">Copied</p> : <p className="m-0">Copy</p>}
                                        </button>
                                        <button className="script_code_btn mt-2" onClick={() => this.toggleQR()}>
                                            <p className="m-0">{this.state.showQR ? "Hide QR" : "Show QR"}</p>
                                        </button>
                                    </div>
                                    {this.state.showQR && (
                                        <div className="text-center mt-3">
                                            <div className="d-inline-block p-3 bg-white border rounded-4 shadow-sm">
                                                <img
                                                    src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                                                        inPatientURL
                                                    )}&size=250x250&margin=25`}
                                                    alt="QR Code"
                                                    className="img-fluid rounded"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-center gap-2 flex-wrap mt-3">
                                                <button
                                                    className="btn btn-primary btn-sm px-3 py-2"
                                                    onClick={() => this.handleDownloadQR(inPatientURL, data && data.patientRoomId)}
                                                >
                                                    <i className="bi bi-download me-1"></i>Download QR
                                                </button>
                                                <button
                                                    className="btn btn-success btn-sm px-3 py-2"
                                                    onClick={() => this.handleCopyQR(inPatientURL)}
                                                >
                                                    <i className="bi bi-clipboard me-1"></i>
                                                    {this.state.isCopied1 ? 'Copied QR Image' : 'Copy QR Image'}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" mt-5 me-5 pb-3 d-flex justify-content-start">
                        <button type="button" className="btn input-btn" onClick={() => this.props.history.goBack()} >{Constants.BACK}</button>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(VendorRoomViewScreen);